import { atom, createStore } from 'jotai';

export const dndItemAtom = atom<string | null>(null);

export const dndStore = createStore();
